import {
  IsNotEmpty,
  IsOptional,
  IsDate,
  IsArray,
  IsNumber,
  IsIn,
  IsBoolean,
  ValidateNested,
  ValidateIf,
} from "class-validator";
import { Type } from "class-transformer";

import { Constants, TitleTrackerVisibilitySettings } from "@eagerdog/constants";

import { RegistrationNumberDto } from "./registration-number.dto";
import { DogCoownerInfoDto } from "./dog-coowner-info.dto";
import { DogOwnerDto } from "./dog-owner.dto";
import { DogVariationDto } from "./dog-variation.dto";
import { DogClubRegistrationDto } from "./club-registration.dto";

export class DogDto {
  @IsOptional()
  @ValidateNested()
  @Type(() => DogOwnerDto)
  owner_info?: DogOwnerDto;

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => DogCoownerInfoDto)
  coowners?: DogCoownerInfoDto[];

  // New club-specific registration structure
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => DogClubRegistrationDto)
  club_registrations?: DogClubRegistrationDto[];

  @IsNotEmpty()
  breed: string;

  @IsOptional()
  variety?: string;

  @IsOptional()
  variations?: DogVariationDto[];

  @IsNotEmpty()
  @IsIn(Object.values(Constants.dog_sex))
  sex: string;

  @IsOptional()
  @IsDate()
  dob?: Date;

  @IsOptional()
  @IsNumber()
  weight?: number;

  @IsOptional()
  @IsNumber()
  height_at_withers?: number;

  @IsOptional()
  final_response?: string;

  @ValidateIf(o => {
    // Skip validation if any club registration is General, CPE, or GCR
    const hasGeneralClub = o.club_registrations?.some((reg: any) => 
      ['General', 'CPE', 'GCR'].includes(reg.sanctioning_club)
    );
    return !hasGeneralClub && o.registered_name !== '';
  })
  @IsNotEmpty()
  registered_name?: string;

  @IsNotEmpty()
  call_name: string;

  @IsOptional()
  prefix_title?: string;

  @IsOptional()
  suffix_title?: string;

  @IsOptional()
  image_url?: string;

  @IsOptional()
  is_archived?: boolean;

  @IsOptional()
  @IsBoolean()
  is_public?: boolean;

  @IsOptional()
  country_of_birth?: string;

  @IsOptional()
  obedience_jump_height?: number;

  @IsOptional()
  rally_jump_height?: number;

  @IsOptional()
  agility_jump_height?: number;

  @IsOptional()
  jump_height_type?: string;

  @IsOptional()
  breeder?: string;

  @IsOptional()
  sire?: string;

  @IsOptional()
  dam?: string;

  @IsOptional()
  needs_measurement?: boolean;

  @IsOptional()
  tracker_visibility_settings?: TitleTrackerVisibilitySettings;

  /** Club numbers */
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => RegistrationNumberDto)
  registration_numbers: RegistrationNumberDto[];
}
